import React, { useState, useRef, useMemo, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import JoditEditor from "jodit-react";

import { GET_CATEGORIA_ARVORE } from "services/Categoria";
import {
  PRE_SAVE_QUESTAO,
  UPLOAD_IMAGEM,
  GET_QUESTAO_ID,
  SAVE_QUESTAO_TEXT_EDITOR,
} from "services/Questao";

import { Accordion, Alert, Row, Form, Col, Badge } from "react-bootstrap";
import Button from "components/_base/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSortDown,
  faSortUp,
  faArrowLeft,
  faSave,
} from "@fortawesome/free-solid-svg-icons";

import { useAlert } from "context/AlertContext";
import { Context } from "context/AuthContext";
import specialCharacters from "./especialCharacter";
import "./styles.scss";

const ContentAdminQuestaoTextEditor = () => {
  const valorInicialResposta = {
    correto: false,
    questaoId: 0,
    respostaId: 0,
    texto: null,
  };
  const valorInicial = {
    questaoId: 0,
    enunciado: "",
    resolucao: "",
    categoriaId: [],
    respostas: [],
    urlImagemEnunciado: "",
    urlImagemResolucao: "",
    imagemEnunciado: null,
    imagemResolucao: null,
    dificuldade: 0,
  };

  const { showLoader } = useContext(Context);
  const { showAlert } = useAlert();

  const [searchTerm, setSearchTerm] = useState("");
  const [questao, setQuestao] = useState(valorInicial);
  const [enunciadoContent, setEnunciadoContent] = useState("");
  const [resolucaoContent, setResolucaoContent] = useState("");
  const [respostasContent, setRespostasContent] = useState(
    new Array(2).fill("")
  );

  const editorEnunciado = useRef(null);
  const editorResolucao = useRef(null);
  // const editorRespostas = useRef([]);
  const alertRef = useRef(null);

  const [categorias, setCategorias] = useState([]);
  const [categoriasSelecionadas, setCategoriasSelecionadas] = useState([]);
  const [erros, setErros] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
  const [tipoResposta, setTipoResposta] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const pageQuery = new URLSearchParams(location.search);
  const id = pageQuery.get("id");

  const config = useMemo(
    () => ({
      readonly: false,
      minHeight: "400px",
      maxWidth: "100%",
      allowResizeX: true,
      toolbarAdaptive: true,
      enableDragAndDropFileToEditor: true,
      showPlaceholder: false,
      disablePlugins:
        "print,about,table,powered-by-jodit,add-new-line,video,speechRecognize,file",
      uploader: {
        insertImageAsBase64URI: true,
      },
      // cleanHTML: {
      //   useIFrameSandBox: true,
      // },
      specialCharacters: specialCharacters,
    }),
    [questao.questaoId]
  );

  useEffect(() => {
    (async () => {
      showLoader(true);
      if (id > 0) {
        const data = await GET_QUESTAO_ID(id);
        const questaoData = data.value;
        // Mapeia os IDs de categorias associadas à questão
        const selectedCategorias = questaoData.questaoCategorias.map(
          (qc) => qc.categoria.categoriaId
        );

        // Define o tipo de resposta com base no número de respostas
        const tipoResposta = questaoData.respostas.length === 2 ? "1" : "2";
        setTipoResposta(tipoResposta);

        // Atualiza o estado da questão incluindo os IDs de categorias
        setQuestao({
          ...questaoData,
          categoriaId: selectedCategorias,
        });

        // Atualiza as categorias selecionadas com a estrutura correta
        setCategoriasSelecionadas(
          questaoData.questaoCategorias.map((qc) => ({
            id: qc.categoria.categoriaId,
            nome: qc.categoria.nome,
          }))
        );
      }


      const categoriaData = await GET_CATEGORIA_ARVORE();
      setCategorias(categoriaData.value);
      showLoader(false);
    })();
  }, [location.search]);

  const handleChange = (e) => {
    setQuestao({ ...questao, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (id !== null) {
      setEnunciadoContent(questao.enunciado || "");
      setResolucaoContent(questao.resolucao || "");
      // setRespostasContent(
      //   questao.respostas
      //     ? questao.respostas.map((resposta) => resposta.texto || "")
      //     : []
      // );
    }
  }, [id, questao.questaoId]);

  useEffect(() => {
    if (window.MathJax) {
      window.MathJax.typesetPromise();
    }
  }, [enunciadoContent, resolucaoContent]);

  const handleEditorBlur = (editorRef, setContent) => (newContent) => {
    if (editorRef.current) {
      window.MathJax.typesetPromise();
      setContent(newContent);
    }
    if (window.MathJax) {
      setTimeout(() => {
        window.MathJax.typesetPromise([editorRef.current.editor]).catch((err) =>
          console.error(err.message)
        );
      }, 0);
    }
  };

  // const handleEditorBlurRespostas = (editorRef, index, setContent) => () => {
  //   const content = editorRef.current[index].value;
  //   window.MathJax.typesetPromise();
  //   setContent((prevContent) => {
  //     const newContent = [...prevContent];
  //     newContent[index] = content;
  //     return newContent;
  //   });
  //   if (window.MathJax) {
  //     setTimeout(() => {
  //       window.MathJax.typesetPromise([editorRef.current.editor]).catch((err) =>
  //         console.error(err.message)
  //       );
  //     }, 0);
  //   }
  // };

  const handleChangeTipoResposta = (event) => {
    const tipo = event.target.value;

    setTipoResposta(tipo);

    if (tipo === "1") {
      setQuestao({
        ...questao,
        respostas: [
          {
            ...valorInicialResposta,
            texto: "Verdadeiro",
          },
          {
            ...valorInicialResposta,
            texto: "Falso",
          },
        ],
      });
    } else if (tipo === "2") {
      setQuestao({
        ...questao,
        respostas: [
          {
            ...valorInicialResposta,
            texto: "A",
          },
          {
            ...valorInicialResposta,
            texto: "B",
          },
          {
            ...valorInicialResposta,
            texto: "C",
          },
          {
            ...valorInicialResposta,
            texto: "D",
          },
          {
            ...valorInicialResposta,
            texto: "E",
          },
        ],
      });
    }
  };

  const handleSelectCorreta = (index) => {
    const novasRespostas = questao.respostas.map((resposta, i) => ({
      ...resposta,
      correto: i === index, // Marca a resposta correta
    }));
    setQuestao({ ...questao, respostas: novasRespostas });
  };

  const saveContent = async () => {
    showLoader(true);

    try {
      let updatedEnunciadoContent = enunciadoContent;
      if (editorEnunciado.current) {
        updatedEnunciadoContent = await uploadImagesInContent(
          enunciadoContent,
          "enunciado"
        );
      }

      let updatedResolucaoContent = resolucaoContent;
      if (editorResolucao.current) {
        updatedResolucaoContent = await uploadImagesInContent(
          resolucaoContent,
          "resolucao"
        );
      }

      // let updatedRespostasContent = [...respostasContent];
      // for (let i = 0; i < editorRespostas.current.length; i++) {
      //   if (editorRespostas.current[i]) {
      //     updatedRespostasContent[i] = await uploadImagesInContent(
      //       respostasContent[i],
      //       `resposta${i + 1}`
      //     );
      //   }
      // }

      const updatedQuestao = {
        ...questao,
        enunciado: updatedEnunciadoContent,
        resolucao: updatedResolucaoContent,
        // respostas: questao.respostas.map((resposta, index) => ({
        //   ...resposta,
        //   texto: updatedRespostasContent[index],
        // })),
      };

      setQuestao(updatedQuestao);

      const data = await SAVE_QUESTAO_TEXT_EDITOR(updatedQuestao)

      if (data.errors) {
        showAlert(data.errors, "danger");
        showLoader(false);
        return;
      }

      if (data) {
        showAlert(
          `Questao ${id === null ? "adicionada" : "atualizada"} com sucessso.`,
          "success"
        );
        navigate("/admin/questao");
      }
    } catch (error) {
      console.error("Erro ao salvar a questão:", error);
    } finally {
      showLoader(false);
    }
  };

  // Usado para pré criar questao, obtendo o id da questao para salvar
  // as imagens criando a pasta com o id da questao

  const preSaveQuestao = async () => {
    showLoader(true);
    const errors = validate();
    if (errors.length > 0) {
      setErros(errors);

      setTimeout(() => {
        if (alertRef.current) {
          alertRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);

      showLoader(false);
      return;
    } else {
      setErros([]);
    }

    if (id === null) {
      try {
        const response = await PRE_SAVE_QUESTAO(valorInicial);
        if (response) {
          setIsUpdating(true);
          setQuestao((prevQuestao) => {
            const updatedQuestao = {
              ...prevQuestao,
              questaoId: response.value.questaoId,
            };
            return updatedQuestao;
          });
        }
      } catch (error) {
        console.error(error);
      }
    } else if (id > 0) {
      saveContent();
    }
  };

  useEffect(() => {
    if (isUpdating) {
      setIsUpdating(false);
      saveContent();
    }
  }, [questao, isUpdating]);

  const base64ToBlob = (base64, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const getUniqueFileName = (originalFileName) => {
    const fileExtension = originalFileName.split(".").pop();
    const baseName = originalFileName.split(".").slice(0, -1).join(".");

    // Obtém a data e hora atual no formato YYYYMMDD_HHMMSS
    const now = new Date();
    const formattedDate = now
      .toISOString()
      .slice(0, 19)
      .replace(/[-:]/g, "")
      .replace("T", "_");

    return `${baseName}_${formattedDate}.${fileExtension}`;
  };
  // const handleAddResposta = () => {
  //   setQuestao((prevQuestao) => ({
  //     ...prevQuestao,
  //     respostas: [...prevQuestao.respostas, { ...valorInicialResposta }],
  //   }));

  //   setRespostasContent((prevRespostasContent) => [
  //     ...prevRespostasContent,
  //     "",
  //   ]);
  // };

  const handleImageUpload = async (imageElement, imageType) => {
    try {
      if (
        imageElement.src.startsWith("http") ||
        imageElement.src.startsWith("https")
      ) {
        return;
      }
      // Extrair o conteúdo base64 da src da imagem
      const base64 = imageElement.src.split(",")[1];
      const contentType = imageElement.src
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      const uniqueFileName = getUniqueFileName("image.png");
      // Converter base64 para Blob
      const file = base64ToBlob(base64, contentType);

      // Criar FormData
      const formData = new FormData();
      formData.append("imageType", imageType);
      formData.append("questaoId", questao.questaoId);
      formData.append("File", file, uniqueFileName);

      try {
        const response = await UPLOAD_IMAGEM(formData);
        if (response && response.files && response.files.length > 0) {
          // Atualiza a src da imagem com a URL retornada
          imageElement.src = response.baseurl + response.path;
        }
      } catch (error) {
        console.error("Erro ao carregar a imagem:", error);
      }
    } catch (error) {
      console.error("Erro ao carregar a imagem:", error);
    }
  };

  const uploadImagesInContent = async (content, imageType) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const images = doc.querySelectorAll("img");

    for (let img of images) {
      await handleImageUpload(img, imageType);
    }

    return doc.body.innerHTML;
  };

  const validate = () => {
    let errors = [];

    if (!enunciadoContent) {
      errors.push({
        nome: "Enunciado",
        message: " O Enunciado é obrigatório",
      });
    } else if (enunciadoContent.length < 30) {
      errors.push({
        nome: "Enunciado",
        message: "Enunciado deve ter no mínimo 10 caracteres",
      });
    }

    if (!resolucaoContent) {
      errors.push({
        nome: "Resolução",
        message: " A Resolução é obrigatória",
      });
    } else if (resolucaoContent.length < 30) {
      errors.push({
        nome: "Resolução",
        message: "Resolução deve ter no mínimo 10 caracteres",
      });
    }

    if (!questao.dificuldade) {
      errors.push({
        nome: "Dificuldade",
        message: "Dificuldade é obrigatória",
      });
    }

    if (questao.categoriaId.length === 0) {
      errors.push({
        nome: "Categoria",
        message: "Deve ter pelo menos 1 categoria selecionada",
      });
    }

    if (questao.respostas.length < 2) {
      errors.push({
        nome: "Respostas",
        message: "Selecione um tipo de resposta",
      });
    }

    questao.respostas.forEach((resposta, index) => {
      if (!resposta.texto) {
        errors.push({
          nome: "Respostas",
          message: `Resposta ${index + 1} é obrigatória`,
        });
      }
    });

    const respostasCorretas = questao.respostas.filter((r) => r.correto);

    if (respostasCorretas.length !== 1) {
      errors.push({
        nome: "Respostas",
        message: "Deve haver exatamente uma resposta correta",
      });
    }

    return errors;
  };

  const handleChangeCategoria = (categoriaIds) => {
    setQuestao((prevQuestao) => ({
      ...prevQuestao,
      categoriaId: categoriaIds,
    }));
  };

  const toggleCategoria = (categoria) => {
    const index = categoriasSelecionadas.findIndex(
      (c) => c.id === categoria.id
    );

    if (index === -1) {
      const newCategoriasSelecionadas = [...categoriasSelecionadas, categoria];
      setCategoriasSelecionadas(newCategoriasSelecionadas);
      handleChangeCategoria(newCategoriasSelecionadas.map((cat) => cat.id));
    } else {
      const newCategoriasSelecionadas = categoriasSelecionadas.filter(
        (cat) => cat.Id !== categoria.Id
      );
      setCategoriasSelecionadas(newCategoriasSelecionadas);
      handleChangeCategoria(newCategoriasSelecionadas.map((cat) => cat.id));
    }
  };

  const toggleExpand = (categoriaId) => {
    setExpandedCategories((prevExpandedCategories) => ({
      ...prevExpandedCategories,
      [categoriaId]: !prevExpandedCategories[categoriaId],
    }));
  };

  const handleSearchChange = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchTerm(searchValue);

    // Atualiza o estado das categorias expandidas para corresponder à pesquisa
    const newExpandedCategories = getExpandedCategoriesForSearch(
      categorias,
      searchValue
    );
    setExpandedCategories(newExpandedCategories);
  };

  const getExpandedCategoriesForSearch = (categories, searchTerm) => {
    const expanded = {};

    // Função recursiva para expandir todos os pais de uma categoria correspondente
    const expandAllParents = (categories, category, expanded) => {
      const parentCategory = categories.find(
        (cat) => cat.id === category.parentId
      );
      if (parentCategory) {
        expanded[parentCategory.id] = true; // Expande o pai
        expandAllParents(categories, parentCategory, expanded); // Expande recursivamente todos os avós
      }
    };

    // Função recursiva para marcar as categorias que precisam ser expandidas
    const markAsExpanded = (cat) => {
      if (cat.nome.toLowerCase().includes(searchTerm)) {
        expanded[cat.id] = true; // Expande a categoria atual
        expandAllParents(categories, cat, expanded); // Expande todos os pais da categoria atual
      }

      if (cat.children && cat.children.length > 0) {
        // Verifica todos os filhos da categoria
        cat.children.forEach((child) => {
          markAsExpanded(child); // Chamada recursiva para filhos
          // Expande o filho se ele corresponder ao termo de pesquisa
          if (
            expanded[child.id] ||
            child.nome.toLowerCase().includes(searchTerm)
          ) {
            expanded[cat.id] = true; // Expande o pai se qualquer filho corresponder
          }
        });
      }
    };

    categories.forEach((cat) => markAsExpanded(cat));
    return expanded;
  };

  // Função para expandir todos os pais
  const expandAllParents = (categories, category, expanded) => {
    const parentCategory = categories.find(
      (cat) => cat.id === category.parentId
    );
    if (parentCategory) {
      expanded[parentCategory.id] = true; // Marca o pai como expandido
      expandAllParents(categories, parentCategory, expanded); // Expande recursivamente para os avós
    }
  };

  const filterCategories = (categories) => {
    return categories
      .map((cat) => {
        const children = filterCategories(cat.children);
        if (
          cat.nome.toLowerCase().includes(searchTerm) ||
          children.length > 0
        ) {
          return {
            ...cat,
            children: children,
          };
        }
        return null;
      })
      .filter((cat) => cat !== null);
  };

  const renderCategoryTree = (categories, parentId = null) => {
    return categories
      .filter((cat) => cat.parentId === parentId)
      .map((cat) => (
        <li key={cat.id}>
          <div className="category-list-item">
            <span
              className="category-list-item-icon-container"
              onClick={() => toggleExpand(cat.id)}>
              {cat.children.length > 0 &&
                (expandedCategories[cat.id] ? (
                  <FontAwesomeIcon icon={faSortUp} />
                ) : (
                  <FontAwesomeIcon icon={faSortDown} />
                ))}
            </span>
            {cat.tipoNome === "Conteúdo" && cat.children && (
              <input
                className="me-2"
                type="checkbox"
                checked={categoriasSelecionadas.some((c) => c.id === cat.id)}
                onChange={() => toggleCategoria(cat)}
              />
            )}
            <span
              className={
                cat.tipoNome === "Área do conhecimento" ||
                  cat.tipoNome === "Matéria"
                  ? "bold-text"
                  : ""
              }>
              {cat.nome}
            </span>
          </div>
          {expandedCategories[cat.id] && cat.children.length > 0 && (
            <ul style={{ listStyle: "none" }}>
              {renderCategoryTree(cat.children, cat.id)}
            </ul>
          )}
        </li>
      ));
  };

  const handleRemoveCategory = (category) => {
    const newCategoriasSelecionadas = categoriasSelecionadas.filter(
      (cat) => cat.id !== category.id
    );
    setCategoriasSelecionadas(newCategoriasSelecionadas);
    handleChangeCategoria(newCategoriasSelecionadas.map((cat) => cat.id));
  };

  return (
    <div className="editor-wrapper mx-auto w-full grow  ">
      <div className="admin-header">
        <h1>Questão</h1>
      </div>
      <hr />
      {erros.length > 0 && (
        <Alert ref={alertRef} variant="danger">
          {erros.map((erro) => (
            <p key={erro.nome}>{erro.message}</p>
          ))}
        </Alert>
      )}
      <Form className="responsive editor-content">
        <Form.Group as={Row} className="m-3">
          <Col sm="12">
            <Form.Group as={Row} className="mb-3">
              <Col sm="2">
                <Form.Label column>Id</Form.Label>
              </Col>
              <Col sm="8">
                <Form.Control
                  name="questaoId"
                  type="number"
                  placeholder="Id"
                  readOnly
                  disabled
                  value={questao.questaoId}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Col sm="2">
                <Form.Label column>Dificuldade</Form.Label>
              </Col>
              <Col sm="8">
                <Form.Select
                  className="custom-select"
                  name="dificuldade"
                  value={
                    questao.dificuldade === null ? [] : questao.dificuldade
                  }
                  onChange={handleChange}>
                  <option value="">Selecione a dificuldade</option>
                  <option value="1">Fácil</option>
                  <option value="2">Médio</option>
                  <option value="3">Difícil</option>
                </Form.Select>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Col sm="2">
                <Form.Label column>Categorias</Form.Label>
              </Col>
              <Col sm="8">
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder="Pesquise pela categoria..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="search-input form-control"
                  />
                  {/* Renderiza as categorias selecionadas como badges */}
                  {categoriasSelecionadas.map((category, index) => (
                    <Badge key={index + 1} className="mx-1 d-inline-flex align-items-center mb-2" bg="primary">
                      {category?.nome}
                      <span
                        className="ms-2 fs-5  fw-bold cursor-pointer"
                        onClick={() => handleRemoveCategory(category)}
                        role="button"
                        aria-label="Remover"
                      >
                        &times;
                      </span>

                    </Badge>
                  ))}
                </div>
                <ul className="categoria-list">
                  {renderCategoryTree(filterCategories(categorias))}
                </ul>
              </Col>
            </Form.Group>


            <Form.Group as={Row} className="mb-3">
              <Col sm="2">
                <Form.Label column>Tipo de resposta</Form.Label>
              </Col>
              <Col sm="8">
                <Form.Select
                  className="custom-select"
                  name="tipoResposta"
                  value={tipoResposta}
                  onChange={handleChangeTipoResposta}>
                  <option value="">Selecione o tipo de resposta</option>
                  <option value="1">Verdadeiro / Falso</option>
                  <option value="2">Múltipla escolha</option>
                </Form.Select>
              </Col>

              {/* Renderiza campos baseados na seleção */}
              <Form.Group as={Row} className="mb-3">
                <Col sm="2">
                  <Form.Label column>Selecione a correta</Form.Label>
                </Col>
                {tipoResposta === "1" && (
                  <Col sm="8" className="mt-3 d-flex flex-row ">
                    {questao.respostas.map((resposta, index) => (
                      <Form.Check
                        key={index + 1}
                        type="radio"
                        label={resposta.texto}
                        name="correto"
                        checked={resposta?.correto}
                        onChange={() => handleSelectCorreta(index)}
                        className="m-2"
                      />
                    ))}
                  </Col>
                )}

                {tipoResposta === "2" && (
                  <Col sm="8" className="mt-3 d-flex flex-row ">
                    {["A", "B", "C", "D", "E"].map((letra, index) => (
                      <Col xs="auto" key={index + 1} className="mb-2">
                        <Form.Check
                          type="radio"
                          label={`${letra}`}
                          name="correto"
                          checked={questao?.respostas[index]?.correto}
                          onChange={() => handleSelectCorreta(index)}
                          className="m-2"
                        />
                      </Col>
                    ))}
                  </Col>
                )}
              </Form.Group>
            </Form.Group>
          </Col>
        </Form.Group>
        <hr />
        <Form.Group as={Row} className="d-flex justify-content-center p-4">
          <Row>
            <Col sm="12">
              <Form.Label column> Enunciado</Form.Label>
              <JoditEditor
                ref={editorEnunciado}
                value={enunciadoContent}
                config={config}
                tabIndex={1}
                onBlur={handleEditorBlur(editorEnunciado, setEnunciadoContent)}
              />
            </Col>
          </Row>
          <hr />
          <Row>
            <Col sm="12">
              <Form.Label column>Resolução</Form.Label>
              <JoditEditor
                ref={editorResolucao}
                value={resolucaoContent}
                config={config}
                tabIndex={2}
                onBlur={handleEditorBlur(editorResolucao, setResolucaoContent)}
              />
            </Col>
          </Row>
        </Form.Group>

        {/*Estava sendo usado para adiconar respostas com joditEdito */}
        {/* <Form.Group as={Row} className="mt-3 responsive">
          <Accordion alwaysOpen defaultActiveKey={["0"]}>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Respostas</Accordion.Header>
              <Accordion.Body className="content-respostas">
                {respostasContent.map((content, index) => (
                  <Accordion key={index}>
                    <Accordion.Item eventKey={index.toString()}>
                      <Accordion.Header>Resposta {index + 1}</Accordion.Header>
                      <Accordion.Body className="container-resposta">
                        <Form.Group
                          as={Row}
                          className="d-flex flex-row align-items-center "
                        >
                          <Col sm="1" className="m-3">
                            <Form.Label column>Correta?</Form.Label>
                          </Col>
                          <Col sm="4">
                            <Form.Check
                              type="checkbox"
                              label="Correto"
                              checked={questao.respostas[index].correto}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setQuestao((prevQuestao) => ({
                                  ...prevQuestao,
                                  respostas: prevQuestao.respostas.map(
                                    (item, idx) =>
                                      idx === index
                                        ? { ...item, correto: isChecked }
                                        : item
                                  ),
                                }));
                              }}
                            />
                          </Col>
                        </Form.Group>
                        <div className="content-editor-resposta">
                          <JoditEditor
                            ref={(el) => (editorRespostas.current[index] = el)}
                            value={content}
                            config={config}
                            tabIndex={1}
                            onBlur={handleEditorBlurRespostas(
                              editorRespostas,
                              index,
                              setRespostasContent
                            )}
                          />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                ))}
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    handleAddResposta();
                  }}
                  className="btn-resposta"
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  Adicionar Resposta
                </Button>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Form.Group> */}
      </Form>
      <div className="content-btns">
        <Button
          className="btn-voltar"
          onClick={() => navigate("/admin/questao")}>
          <FontAwesomeIcon icon={faArrowLeft} />
          <span className="ps-1">Voltar</span>
        </Button>

        <Button
          className="btn-salvar"
          onClick={(e) => {
            e.preventDefault();
            preSaveQuestao();
          }}>
          <FontAwesomeIcon icon={faSave} />
          <span className="ps-1">Salvar</span>
        </Button>
      </div>
      <hr />
    </div>
  );
};

export default ContentAdminQuestaoTextEditor;
